'use client'

import { useRouter } from 'next/navigation'
import { Icon } from 'shared/iconpack'
import { IconNames } from 'shared/iconpack/model/types'

import { RouterPath } from 'shared/config/routerPath/RouterPath'
import { globalStyles } from 'shared/config/styles/globalStyles'

import styles from './MenuItem.module.scss'

type MenuItem = {
  path: RouterPath
  icon: IconNames
  label: string
  isActive: boolean
}

export function MenuItem({ path, icon, label, isActive }: MenuItem) {
  const router = useRouter()
  return (
    <span
      key={path}
      onClick={() => router.push(path)}
      className={`${styles.link} ${isActive ? styles.active : ''}`}
    >
      <Icon
        name={icon}
        size={20}
        color={
          isActive
            ? globalStyles['--icon-sucess']
            : globalStyles['--icon-secondary']
        }
      />
      <span className={styles.text}>{label}</span>
    </span>
  )
}
